import { useLayoutEffect as e } from "@radix-ui/react-use-layout-effect";
import * as t from "react";
const r = t["useId".toString()] || (() => {});
let i = 0;
export function useId(n) {
  const [o, s] = t.useState(r());
  return e(() => {
    n || s(e => null != e ? e : String(i++));
  }, [n]), n || (o ? `radix-${o}` : "");
}
export function IdProvider(_ref) {
  let {
    children: e
  } = _ref;
  return t.useEffect(() => {
    console.warn(n);
  }, []), /*#__PURE__*/t.createElement(t.Fragment, null, e);
}
const n = "Warning: The `IdProvider` has been deprecated. For details, see https://radix-ui.com/docs/primitives/utilities/id-provider";